import { useState, useEffect, lazy } from "react";
import { fetchJson } from "../../helpers";
import { project_header_json_path } from '~/routes';
import Tooltip from '../common/Tooltip'
import withSuspense from "../../helpers/withSuspense.jsx";
const ProjectHeaderDropdownMenu = withSuspense(lazy(() => import("./ProjectHeaderDropdownMenu.jsx")), <></>);

const ProjectHeader = ({header, permissions = {}}) => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([]);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    fetchJson(
      project_header_json_path(),
      {
        method: 'POST',
        body: JSON.stringify({ project_id: header.project_id })
      }
    ).then(res => {
      setItems(res.items);
      setAnswers(res.answers)
      setLoading(false)
    }).catch(err => console.error(err));
  }, [header.project_id]);

  const headerItem = (item) => {
    const {
      render_options: renderOptions = {},
      label,
      report_key: reportKey,
      type,
      free_text
    } = item;

    const commonStyle = {
      color: renderOptions.color,
      background: renderOptions.background_color
    };

    const tooltipTitle = label?.[I18n.locale] ?? '';
    const text = reportKey && answers[reportKey] != null ? answers[reportKey] : free_text ?? '';

    const renderers = {
      tag: () => (
        <Tooltip title={tooltipTitle}>
          <span className="label header-tag" style={commonStyle}>
            {text}
          </span>
        </Tooltip>
      ),
      icon: () => text ? (
        <Tooltip title={tooltipTitle}>
          <i
            className={`fa fa-${renderOptions.icon_type} header-icon`}
            style={commonStyle}
          />
          <span>{` ${text}`}</span>
        </Tooltip>
      ) : null,
      text: () => <span>{text}</span>,
      text_bold: () => <strong>{text}</strong>
    };

    return renderers[type] ? renderers[type]() : null;
  };

  return (
    <div>
      <h1>
        {header.project.project_title}
        <ProjectHeaderDropdownMenu
          projectId={header.project_id}
          permissions={permissions}
        />
      </h1>
      <div className='ml-1' style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <div>{header.project.project_identifier}</div>
        {!loading && <>
          {items.map((item) => (
            headerItem(item)
          ))}
        </>
        }
      </div>
    </div>
  );
};

export default ProjectHeader;
